import React, { Component } from "react";
import { connect } from "react-redux";
import { OnePageHeader, SrhJumbotron, WatermarkedDiv } from "./style.js";
import SRHCopyright from "./../../../../components/SRHCopyright";
import Printable from "./../../../../components/Printable";
import logo from "./../../../../assets/img/logo/logo-stacked.png";
import Grid from "@material-ui/core/Grid";

class TitlePage extends Component {
  autosizeH2Font = (text) => {
    return text.length <= 45
      ? ""
      : text.length <= 55
      ? "smaller-x1"
      : text.length <= 65
      ? "smaller-x2"
      : text.length <= 75
      ? "smaller-x3"
      : text.length <= 85
      ? "smaller-x4"
      : text.length <= 100
      ? "smaller-x5"
      : "truncate";
  };

  magnetReportHeaderContents = (magnetReport, domainCombination) => {
    const passCount = domainCombination.pass;
    const percent = Math.floor((passCount * 100) / domainCombination.units.length);
    const nameWithPeriod = `${magnetReport.datasetName} - ${magnetReport.surveyPeriod}`;
    const datasetUnitName = magnetReport.datasetUnitNamePlural ? magnetReport.datasetUnitNamePlural : "Work Settings";
    return (
      <div>
        <h1>MAGNET Report</h1>
        <h2 className={this.autosizeH2Font(nameWithPeriod)}>{nameWithPeriod}</h2>
        <h4>
          {magnetReport.workSettingsSurveyed} {datasetUnitName} - {magnetReport.totalRespondents} Respondents -{" "}
          {passCount} {datasetUnitName} Pass ({percent}%)
        </h4>
      </div>
    );
  };

  facilityMagnetReportHeaderContents = (magnetReport) => {
    const nameWithPeriod = `${magnetReport.datasetName} - ${magnetReport.surveyPeriod}`;
    const datasetUnitName = magnetReport.datasetUnitNamePlural ? magnetReport.datasetUnitNamePlural : "Work Settings";
    return (
      <div>
        <h1>MAGNET Questions Report</h1>
        <h2 className={this.autosizeH2Font(nameWithPeriod)}>{nameWithPeriod}</h2>
        <h4>{`${magnetReport.workSettingsSurveyed} ${datasetUnitName} Surveyed - ${magnetReport.totalRespondents} Respondents`}</h4>
      </div>
    );
  };

  unitMagnetReportHeaderContents = (magnetReport, unit) => {
    const nameWithPeriod = `${unit.name} - ${magnetReport.surveyPeriod}`;
    return (
      <div>
        <h1>MAGNET Questions Report</h1>
        <h2 className={this.autosizeH2Font(nameWithPeriod)}>{nameWithPeriod}</h2>
        <h3>{magnetReport.datasetName}</h3>
        <h4>
          {unit.responseCount} Respondents{unit.responseRate ? ` - Response Rate ${unit.responseRate}%` : ""}
        </h4>
      </div>
    );
  };

  render() {
    let { magnetReport, unit, domainCombination, ready } = this.props;
    let header;
    if (ready) {
      if (!unit) {
        header = this.magnetReportHeaderContents(magnetReport, domainCombination);
      } else if (unit.name === "facility") {
        header = this.facilityMagnetReportHeaderContents(magnetReport);
      } else {
        header = this.unitMagnetReportHeaderContents(magnetReport, unit);
      }
      return (
        <Printable>
          <OnePageHeader>
            <img src={logo} alt="Logo" />
          </OnePageHeader>
          <SrhJumbotron>{header}</SrhJumbotron>
          <WatermarkedDiv>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <h4>The Magnet SCORE Survey</h4>
                <p>The Magnet SCORE survey measures important dimensions of registered nurse (RN) satisfaction.</p>
                <p>
                  The survey integrates the measurement of RN satisfaction in seven domains. These domains include
                  autonomy, professional development, leadership access and responsiveness, interprofessional
                  relationships, fundamentals of quality nursing care, adequacy of resources, and RN-to-RN teamwork and
                  communication.
                </p>
                <p>
                  The insights are critical for organizational improvement and the ability to drive habitual nursing
                  excellence.
                </p>
              </Grid>
              <Grid item xs={6}>
                <h4>Why is Magnet Recognition Important?</h4>
                <p>
                  The Magnet Recognition designation is the highest and most prestigious designation organizations can
                  receive for their hard-earned commitment to nursing excellence, quality patient care and contented
                  nurses at its heart.
                </p>
                <p>
                  Studies show Magnet hospitals have higher percentages of satisfied registered nurses (RNs), lower RN
                  turnover and vacancy, improved clinical outcomes, greater nurse autonomy, and improved patient
                  satisfaction.
                </p>
                <p>
                  Specific actions to leverage organizational strengths and address areas of fundamental opportunity are
                  easily identified.
                </p>
              </Grid>
            </Grid>
          </WatermarkedDiv>
          <SRHCopyright textClass={!magnetReport ? "large-font" : ""} noImage />
        </Printable>
      );
    } else {
      return <Printable />;
    }
  }
}
export default connect((store) => {
  return {
    magnetReport: store.magnetReport.magnetReport,
  };
})(TitlePage);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/TitlePage/index.jsx